// apps/roleforge-app/src/components/audit/Year1SavingsLine.tsx
//
// Plan 3e-ii Task 5.6 — Year-1 savings headline (floor + optional
// italic ceiling) for the Activation Moment screen.

function formatUsd(cents: number): string {
  const dollars = Math.round(cents / 100);
  return `$${dollars.toLocaleString('en-US')}`;
}

export interface Year1SavingsLineProps {
  floorCents: number;
  ceilingCents: number | null;
}

export function Year1SavingsLine({ floorCents, ceilingCents }: Year1SavingsLineProps) {
  return (
    <div className="my-6 text-center">
      <p className="text-xs uppercase tracking-wide text-slate-500 mb-1">
        Estimated Year-1 savings
      </p>
      <p className="text-3xl font-bold text-slate-900 dark:text-slate-100" data-testid="floor">
        {formatUsd(floorCents)}
      </p>
      <p className="text-xs text-slate-500 mt-1">Floor (cost-savings only)</p>
      {ceilingCents !== null && (
        <p className="text-sm italic text-slate-500 mt-3" data-testid="ceiling">
          Ceiling (with reallocation): {formatUsd(ceilingCents)}{' '}
          <span className="text-xs">
            — if 50% of saved hours redirect to revenue work (potential, not guaranteed)
          </span>
        </p>
      )}
    </div>
  );
}
